import axiosInstance from '@/utils/api.js'

var state = {
  documentTemplates: []
}

var getters = {
  DOCUMENT_TEMPLATES: (state) => {
    return state.documentTemplates
  }
}

var mutations = {
  SET_DOCUMENT_TEMPLATES: (state, payload) => {
    state.documentTemplates = payload
  }
}

var actions = {
  GET_DOCUMENT_TEMPLATES: async (context, payload) => {
    let result = await axiosInstance.get('/settings/documents/templates')
    if (result.status === 200) {
      context.commit('SET_DOCUMENT_TEMPLATES', result.data)
    }
  },
  CREATE_DOCUMENT_TEMPLATES: (context, payload) => {
    return axiosInstance.post('/settings/documents/templates?name=' + payload.name + '&type=' + payload.type, payload.contents)
  },
  UPDATE_DOCUMENT_TEMPLATES: (context, payload) => {
    return axiosInstance.put('/settings/documents/templates?name=' + payload.name + '&type=' + payload.type + '&template_id=' + payload.template_id, payload.contents)
  },
  DELETE_DOCUMENT_TEMPLATES: (context, payload) => {
    return axiosInstance.delete('/settings/documents/templates?template_id=' + payload)
  },
  DOWNLOAD_FILE_DOCUMENT_TEMPLATES: (context, payload) => {
    return axiosInstance.get('/settings/documents/template_download?template_id=' + payload, {
      responseType: 'blob'})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/documentTemplates.js